import { SceneWithProgress } from '../pages/Lobby/ScenesProgressProvider';
const sortingOrder = {
  TRAINING: 2,
  TOURNAMENT: 3,
  UNFINISHED: 1,
};

export function compareWithPriority(
  a: SceneWithProgress,
  b: SceneWithProgress,
) {
  const prioritySumA = (a.statuses || []).reduce(
    (sum, status) => sum + sortingOrder[status],
    0,
  );
  const prioritySumB = (b.statuses || []).reduce(
    (sum, status) => sum + sortingOrder[status],
    0,
  );

  return prioritySumB - prioritySumA;
}
